import * as types from './mutation-types'

const state = {
  categories: [],
  protocols: [],
  protocol: {}
}

const mutations = {
  [types.UPDATE_CATEGORIES] (state, payload) {
    state.categories = payload.categories
  },
  [types.UPDATE_PROTOCOLS] (state, payload) {
    state.protocols = payload.protocols
  },
  [types.SELECT_PROTOCOL] (state, payload) {
    state.protocol = payload.data
  }
}

export default {
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/mutations.js